import {
	Component,
	Output,
	EventEmitter,
	Input,
	ChangeDetectionStrategy,
} from '@angular/core';
import { MatterDispatch } from '@state/matter';
import { MatterFields } from '@models/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './title-search-completion-date.hooks';
import { AI_GENERATED_ICON } from '@core/util/icon';
import { tap, map } from 'rxjs/operators';
import { Store } from '@ngxs/store';

@Component({
	selector: 'app-sale-title-search-completion-date',
	templateUrl: './title-search-completion-date.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleSearchCompletionDateComponent {
	testHooks = TestHooks;
	private closingDate: string;
	private titleSearchCompletionDate: string;
	public AI_ICON = AI_GENERATED_ICON.icon;
	public AI_TOOLTIP = AI_GENERATED_ICON.tooltip;
	public AI_CLASSES = AI_GENERATED_ICON.classes;

	@Input() skeletonLoading = false;
	@Output() onFocus = new EventEmitter<string>();

	public titleSearchCompletionDateFieldMapping$ = this.store
		.select(SelectedMatter.getFieldMappings)
		.pipe(map((fieldMappings) => fieldMappings?.titleSearchCompletionDate));
	public closingDate$ = this.store.select(SelectedMatter.closingDate).pipe(
		tap((date) => {
			this.closingDate = date;
		}),
	);
	public titleSearchCompletionDate$ = this.store
		.select(SelectedMatter.titleSearchCompletionDate)
		.pipe(
			tap((date) => {
				this.titleSearchCompletionDate = date;
			}),
		);
	public field = MatterFields.TITLE_SEARCH_COMPLETION_DATE;

	constructor(
		private matterDispatch: MatterDispatch,
		private store: Store,
	) {}

	_onFocus() {
		this.onFocus.emit(this.field);
	}

	onChange = (event: string) => {
		if (
			this.titleSearchCompletionDate !== event &&
			(!event || !this.closingDate || this.closingDate >= event)
		) {
			this.matterDispatch.OverwriteFields('titleSearchCompletionDate', event);
		}
	};
}
